import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "steps__step-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "h4 h4--b" }, " Please provide the most accurate information available regarding the project deliverables ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-24" }, " All fields are required unless indicated as optional. ", -1 /* HOISTED */)
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = { class: "form__set form__set--wrap" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "h5 h5--b" }, " Project Deliverables ", -1 /* HOISTED */)
const _hoisted_7 = { class: "h5" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "light"
}
const _hoisted_10 = { class: "light" }
const _hoisted_11 = { class: "mb-32" }
const _hoisted_12 = { class: "h5" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "light" }, "Total project cost:", -1 /* HOISTED */)
const _hoisted_14 = {
  class: "button button--fill",
  type: "submit"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("form", {
      class: "form form--fixed-fields",
      onSubmit: _withModifiers($setup.updateForm, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.billing_location,
          type: "select",
          "input-id": "billing-location",
          name: "billing-location",
          label: "Billing Location",
          options: $setup.billing_locations,
          required: true,
          errors: $setup.form_errors.billing_location || null,
          "onUpdate:value": _cache[0] || (_cache[0] = new_value => $setup.form_fields.billing_location = new_value)
        }, null, 8 /* PROPS */, ["value", "options", "errors"]),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.production_office,
          type: "select",
          "input-id": "production-office",
          name: "production-office",
          label: "Production Office",
          options: $setup.offices,
          required: true,
          errors: $setup.form_errors.production_office || null,
          "onUpdate:value": _cache[1] || (_cache[1] = new_value => $setup.form_fields.production_office = new_value)
        }, null, 8 /* PROPS */, ["value", "options", "errors"]),
        _createVNode($setup["InputComponent"], {
          value: $setup.form_fields.currency,
          type: "select",
          "input-id": "currency",
          name: "currency",
          label: "Currency",
          options: $setup.currencies,
          required: true,
          errors: $setup.form_errors.currency || null,
          "onUpdate:value": _cache[2] || (_cache[2] = new_value => $setup.form_fields.currency = new_value)
        }, null, 8 /* PROPS */, ["value", "options", "errors"])
      ]),
      ($setup.scope)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_6,
            _createElementVNode("h3", _hoisted_7, [
              ($setup.scope.sequence_prefix)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.scope.sequence_prefix) + "  ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              ($setup.scope.sequence_prefix)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, " —  "))
                : _createCommentVNode("v-if", true),
              _createElementVNode("span", _hoisted_10, _toDisplayString($setup.scope.title), 1 /* TEXT */)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.scope.items, (item, index) => {
              return (_openBlock(), _createBlock($setup["ProjectDeliverableComponent"], {
                key: 'scope-item' + index,
                deliverable: item,
                currency: $setup.selected_currency
              }, null, 8 /* PROPS */, ["deliverable", "currency"]))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString($setup.total), 1 /* TEXT */)
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("button", _hoisted_14, " Save " + _toDisplayString($props.stepTitle), 1 /* TEXT */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_4)
  ]))
}